var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__banner-ad--wrapper",attrs:{"id":"cz2__banner-ad--wrapper"}},[(_vm.staticContent)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.staticContent)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }